module.exports = __webpack_public_path__ + "img/p-11.58943865.webp";